import React, {useState, useEffect} from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	Grid,
} from "@material-ui/core";
import API from "../../network/dashboardAPI";
import CountryCodeSelect from "../CountryCode";
import GoogleMaps from "../CustomerAddress/GoogleMap";
import {addressDetail} from "../../store/actions/userAction";

const EditCustomerAddress = (props) => {
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [areaDetails, setAreaDetails] = useState("");
	const [city, setCity] = useState("");
	const [countryCode, setCountryCode] = useState({
		label: "Cambodia (+855)",
		value: 855,
	});
	const [deliveryInstructions, setDeliveryInstructions] = useState("");
	const [houseAndStreet, setHouseAndStreet] = useState("");
	const [landmark, setLandmark] = useState("");
	const [mobileNumber, setMobileNumber] = useState("");
	const [nickName, setNickName] = useState("Home");
	const [streetDetails, setStreetDetails] = useState("");
	const [apartmentName, setApartmentName] = useState("");
	const [district, setDistrict] = useState("");
	const [commune, setCommune] = useState("");
	const [latitude, setLatitude] = useState(11.585059400964562);
	const [longitude, setLongitude] = useState(104.91634500155044);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		console.log("Props in useEffect:", {
			data: props.data,
			userData: props.userData,
			addressEdit: props.addressEdit,
		});

		const data = props.data || {};
		const userData = props.userData || {};
		const isEdit = !props.addressEdit;

		setFirstName(isEdit ? userData.first_name || "" : data.first_name || "");
		setLastName(isEdit ? userData.last_name || "" : data.last_name || "");
		setAreaDetails(data.area_details || "");
		setCity(data.city || "");
		setCountryCode(
			isEdit
				? userData.country_code
				: data.country_code
		);
		setDeliveryInstructions(data.delivery_instructions || "");
		setHouseAndStreet(data.house_and_street || "");
		setMobileNumber(isEdit ? userData.phone || "" : data.mobile_number || "");
		setNickName(data.nick_name || "");
		setStreetDetails(data.street_details || "");
		setApartmentName(data.apartment_name || "");
		setDistrict(data.district || "");
		setCommune(data.commune || "");
		setLatitude(data.latitude || 11.5850594);
		setLongitude(data.longitude || 104.916345);
		setLoading(false)
	}, [props.data, props.userData, props.addressEdit]);
	const handleUpdateAddress = async () => {
		// if (!props.data?.address_id) return;

		const body = {
			first_name: firstName,
			last_name: lastName,
			mobile_number: mobileNumber,
			house_and_street: houseAndStreet,
			street_details: streetDetails,
			area_details: areaDetails,
			city: city,
			commune: commune,
			district: district,
			nick_name: nickName,
			is_default: props.data?.is_default,
			latitude: latitude,
			long: longitude,
			delivery_instructions: deliveryInstructions,
			country_code: countryCode.value,
			apartment_name: apartmentName,
		};

		props.setIsUpdateAddressRequest(true);

		try {
			let response
			if (props.addressEdit) {
				response = await API.UpdateAddress(props.data.address_id, body).then((res) => res.json());
			} else {
				response = await API.CreateAddress(props?.userData?.cust_id, body).then((res) => res.json());
			}
			if (response.success) {
				props.setIsUpdateAddressRequest(false);
				props.setItemListDeliveryAddr(response.data.allAddress);
				props.setListAddress(response.data.allAddress);
				props.handleToggle();
			}
		} catch (error) {
			alert(error.message || "Failed to update address");
			console.error("Update Address Failed:", error);
			props.setIsUpdateAddressRequest(false);
		}
	};

	const handleMarkerDragEnd = async (props, {lat, lng}) => {
		const response = await API.adminAddressGeoCod({lat, lng});
		const address = await response.json();
		console.log("Address from handleMarkerDragEnd:", address);
		if (address.success) {
			setLatitude(lat);
			setLongitude(lng);
			setCity(address.data.city || "");
			setHouseAndStreet(address.data.houseAndStreet || "");
			setAreaDetails(address.data.label || "");
			setDistrict(address.data.district || "");
			setCommune(address.data.commune || "");
			setApartmentName(address.data.apartmentName || "");
		}
	};

	const myLocation = async (props, {lat, lng}) => {
		const response = await API.adminAddressGeoCod({lat, lng});
		const address = await response.json();
		console.log("Address from myLocation:", address);
		if (address.success) {
			setLatitude(lat);
			setLongitude(lng);
			setCity(address.data.city || "");
			setHouseAndStreet(address.data.houseAndStreet || "");
			setAreaDetails(address.data.label || "Home");
			setDistrict(address.data.district || "");
			setCommune(address.data.commune || "");
			setApartmentName(address.data.apartmentName || "");
		}
	};

	const setLatLng = (latlng) => {
		setLatitude(latlng.lat);
		setLongitude(latlng.lng);
	};

	if (loading) {
		return (
			<Dialog open={props.modal}>
				<DialogContent>Loading...</DialogContent>
			</Dialog>
		);
	}

	return (
		<Dialog open={props.modal} onClose={props.handleToggle} fullWidth maxWidth="md" style={{zIndex: 1000}}>
			<DialogTitle>Update Address</DialogTitle>
			<DialogContent dividers>
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<GoogleMaps
							isMarkerShown={true}
							latitude={latitude}
							longitude={longitude}
							onMarkerDragEnd={handleMarkerDragEnd}
							onMyLocation={myLocation}
							fetchAddress={() => {
							}}
							type={!props.addressEdit && "create"}
							setLatLng={setLatLng}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="City"
							value={city}
							onChange={(e) => setCity(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="District"
							value={district}
							onChange={(e) => setDistrict(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="Commune"
							value={commune}
							onChange={(e) => setCommune(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="House/Street"
							value={houseAndStreet}
							onChange={(e) => setHouseAndStreet(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="Apartment Name"
							value={apartmentName}
							onChange={(e) => setApartmentName(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="Label"
							value={nickName}
							onChange={(e) => setNickName(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							fullWidth
							multiline
							minRows={4}
							label="Delivery Instruction"
							value={deliveryInstructions}
							onChange={(e) => setDeliveryInstructions(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="First Name"
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="Last Name"
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={6}>
						<CountryCodeSelect
							onChange={(option) => setCountryCode(option)}
							value={countryCode}
							placeholder="Country Code"
							name="Country Code"
							error={false}
						/>
					</Grid>
					<Grid item xs={6}>
						<TextField
							fullWidth
							label="Mobile"
							value={mobileNumber}
							onChange={(e) => setMobileNumber(e.target.value)}
							variant="outlined"
						/>
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={props.handleToggle} color="secondary">
					Close
				</Button>
				<Button onClick={handleUpdateAddress} variant="contained" color="primary">
					Update
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default React.memo(EditCustomerAddress);